module.exports = __webpack_public_path__ + "static/img/logohpca3.6ff1407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logohpca3.png
// module id = zF+B
// module chunks = 1